import { createFileRoute, useParams } from '@tanstack/react-router';

import { AwardsTab } from '@/views/admin/courses/tabs/awards-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/awards')({
  component: AwardsRoute,
});

function AwardsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/awards' });
  return <AwardsTab id={id} />;
}
